import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { updateEntityAction } from 'actions/entityActions'
import { convertedDropLengthSelector } from 'selectors/components'
import networkClosetDefaults from 'helpers/networkClosets/defaults'
import { doorControllerDefaults } from 'helpers/accessControl/defaults'
import convertUnitFromMap from 'helpers/convertUnitFromMap'
import convertUnitToMap from 'helpers/convertUnitToMap'
import tippy from 'tippy.js'

const mapStateToProps = state => {
  return {
    dropLength: convertedDropLengthSelector(state),
    isImperial: state.ui.isImperial
  }
}

class DropLengthInput extends React.Component {
  isDefaultDropLength = _ => {
    const { dropLength, isImperial, door } = this.props
    const defaultDropLength = door ? doorControllerDefaults.dropLength : networkClosetDefaults.dropLength
    const convertedDropLength = isImperial ? defaultDropLength : Math.round(convertUnitToMap({ value: defaultDropLength, isImperial: true }))

    return dropLength === convertedDropLength
  }

  constructor(props) {
    super(props)
    this.state = { errorText: null, isDefault: this.isDefaultDropLength() }
  }

  componentDidMount = _ => tippy(`.${this.props.classes.helpIcon}`, { duration: 0, theme: 'topbar', placement: 'top' })

  componentWillUnmount = _ => {
    const { state: { errorText }, props: { id, door, updateEntityAction } } = this

    // reset invalid values
    if (errorText) updateEntityAction(door ? 'doorControllers' : 'networkClosets', id, { dropLength: door ? doorControllerDefaults.dropLength : networkClosetDefaults.dropLength })
  }

  update = ({ target: { value } }) => {
    const { id, isImperial, door, updateEntityAction } = this.props
    this.setState({ isDefault: false })

    if ((value === undefined) || (value.length === 0) || !value.trim()) {
      return this.setState({ errorText: 'Invalid number' })
    }

    const dropLength = parseFloat(value)
    if (isNaN(dropLength) || (dropLength < 0)) {
      return this.setState({ errorText: 'Must be at least 0' })
    }

    const upperBound = isImperial ? 100 : 30
    if (dropLength >= upperBound) {
      return this.setState({ errorText: `Must be less than ${upperBound}` })
    }

    this.setState({ errorText: null })
    updateEntityAction(door ? 'doorControllers' : 'networkClosets', id, { dropLength: isImperial ? dropLength : convertUnitFromMap({ value: dropLength, isImperial: true }) })
  }

  resetDefault = _ => {
    if (this.state.isDefault) {
      this.setState({ isDefault: false })
      this.refs.input.value = ''
    }
  }

  render() {
    const { update, resetDefault, isDefaultDropLength, props: { containerClass, desktop, dropLength, isImperial, door, classes }, state: { errorText, isDefault } } = this

    return (
      <div className={containerClass}>
        <span className={classes.label}>
          Total Service Loop{ desktop && (door ? ' Per Door' : ' Per Cable') }
          <a className={classes.helpIcon} title='Combined extra cable at each end of the horizontal run'>
            <FontAwesomeIcon icon='info-circle' />
          </a>
        </span>
        <input
          type='number'
          className={classes.input + (errorText ? ' invalid' : '') + (isDefault ? ' default' : '')}
          onChange={update}
          onFocus={resetDefault}
          defaultValue={dropLength}
          min={0}
          max={isImperial ? 99 : 29}
          step={1}
          ref='input'
        />
        { errorText
          ? <span className={classes.errorText}>{errorText}</span>
          : `${isImperial ? 'ft' : 'm'}` + (isDefaultDropLength() ? ' (default)' : '')
        }
      </div>
    )
  }
}

export default connect(mapStateToProps, { updateEntityAction })(injectSheet(style)(DropLengthInput))



// WEBPACK FOOTER //
// ./src/components/NetworkClosetDetails/DropLengthInput/index.js